<template>
  <div class="footer cl">
    <div class="contact auto ovh">
      <!-- <div class="l logo"></div> -->
      <img class="l logo" src="../assets/logo2.png" alt="logo">
      <div class="l contact-item">
        <div class="f22 g3 tl mt20">广州匠心网络科技有限公司</div>
        <ul class="g6 f16 contact-detail ovh mt5">
          <li class="l">公司地址： 广州市天河区棠安路119号金悦大厦617</li>
          <li class="l split">|</li>
          <li class="l">联系电话/微信：老夏 <a class="g6" href="tel:18502074878">18502074878</a></li>
          <li class="l split">|</li>
          <li class="l">联系邮箱：<a class="g6" href="mailto:xia.sakey@foxmail.com">xia.sakey@foxmail.com</a></li>
        </ul>
      </div>
    </div>
    <div>
      <ul class="g6 f16 ovh mt5 dos-list auto">
        <li class="l"><a target="_blank" href="./doc/userAgreement.html">用户协议</a></li>
        <li class="l split">/</li>
        <li class="l"><a target="_blank" href="./doc/MonitoringProject.html">监护工程</a></li>
        <li class="l split">/</li>
        <li class="l"><a target="_blank" href="./doc/AlternativeDisputeResolution.html">纠纷处理</a></li>
        <li class="l split">/</li>
        <li class="l"><a target="_blank" href="./doc/AntiAddiction.html">防沉迷系统</a></li>
        <li class="l split">/</li>
        <li class="l"><a target="_blank" href="./doc/PrivacyPolicy.html">隐私政策</a></li>
      </ul>
    </div>
    <div class="split-line"></div>
    <div class="copyright f18 g3 mt30">Copyright © {{year}} 广州匠心网络科技有限公司&nbsp;&nbsp;&nbsp;版权所有 All Rights Reserve.</div>
    <div class="icps auto ovh">
      <!-- <div class="f18 g3 mt1 icp l"><a class="f18 g3" href="./doc/icp.jpg" target="_blank">粤B2-20180019</a></div> -->
      <div class="f18 g3 mt1 icp1 l"><a class="f18 g3" href="http://beian.miit.gov.cn" target="_blank">粤ICP备20072126号</a></div>
      <!-- <div class="f18 g3 mt1 icp2 l"><a class="f18 g3" href="http://sq.ccm.gov.cn/ccnt/sczr/service/business/emark/toDetail/7b055a4af580411281986e9195b87334?tdsourcetag=s_pctim_aiomsg" target="_blank">粤网文〔2017〕8721-2182号</a></div> -->
    </div>
    <!-- <div class="icps auto ovh" style="width:290px;">
      <div class="f18 g3 mt1 icp1 l" style="width:290px;"><a class="f18 g3" href="http://beian.gov.cn/portal/registerSystemInfo?recordcode=44010602006833" target="_blank">粤公网安备 44010602006833号</a></div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'PageFooter',
  props: {
    msg: String
  },
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.footer {
  padding: 68px 0;
  background: rgb(245,246,249);
  .logo {
    width: 208px;
    height: 80px;
  }
  .contact {
    width: 1320px;
    .split {
      margin: 0 8px;
    }
  }
  .contact-item {
    margin-left: 30px;
  }
  .contact-detail {
    padding: 0;
  }
  .split-line {
    width: 1000px;
    margin: 40px auto 0 auto;
    border-bottom: 1px solid rgba($color: #333333, $alpha: 0.2);
  }
  .icps {
    width: 655px;
  }
  .icp {
    background: url('../assets/icon-police.png') no-repeat left center / 14px 16px;
    width: 165px;
  }
  .icp1 {
    background: url('../assets/icon-police.png') no-repeat left center / 14px 16px;
    width: 215px;
  }
  .icp2 {
    background: url('../assets/wenhuajingying.png') no-repeat left center / 18px;
    width: 274px;
  }
  .dos-list {
    padding-left: 238px;
    width: 902px;
    line-height: 21px;
    color: #222222 !important;
    .split {
      margin: 0 3px;
    }
    a {
      color: #222222 !important;
    }
  }
}
</style>
